import { Component } from '@angular/core';

@Component({
    selector: 'app-dimensionalanalysis',
    templateUrl: './dimensionalanalysis.component.html',
    styleUrl: './dimensionalanalysis.component.scss',
    standalone: false
})
export class DimensionalanalysisComponent {

}
